<template>
    <div class="ourStoryBG">
        <el-row>
            <el-col :span="8" :offset="2" class="card storyHidden">
                <el-card>
                    <div style="width:100%;height:5vh"></div>
                    <el-image style="height:30vh;width:auto" src="https://img.codesocean.top/image/1666764199548" fit="contain"></el-image>
                    <br/>
                    <span class="name female">
                        张小兔
                    </span>
                    <br/>
                    <span class="motto">
                        自己有了光芒才配得上自己追逐的星星
                    </span>
                    <br/>
                    <el-divider><i class="el-icon-female icon"></i></el-divider>
                    <span class="content">
                        是一个可爱的小女孩，现在在学小学教育
                        <br/>
                        以后会当一个光荣伟大的人民教师
                        <br/>
                        现在在勤奋学习中
                        <br/>
                        在为自己追逐的星星而不断让自己闪烁光芒
                        <br/>
                    </span>
                </el-card>
            </el-col>
            <el-col :span="2" :offset="1" style="margin-top:20vh" class="storyHidden">
                <el-image src="https://img.codesocean.top/image/1666766937925"></el-image>
                <br/>
                <el-image src="https://img.codesocean.top/image/1666810987379"></el-image>
            </el-col>
            <el-col :span="8" :offset="1" class="card storyHidden">
                <el-card>
                    <el-image style="height:35vh;width:auto;" src="https://img.codesocean.top/image/1666764289640" fit="contain"></el-image>
                    <br/>
                    <span class="name male">
                        杨小鱼
                    </span>
                    <br/>
                    <span class="motto">
                        前行是必然，道路在脚下
                    </span>
                    <br/>
                    <el-divider><i class="el-icon-male icon"></i></el-divider>
                    <span class="content">
                        是一个阳光的大男孩，现在在学软件工程
                        <br/>
                        以后会当一个软件工程师，也就是个程序员
                        <br/>
                        现在也在勤奋学习中
                        <br/>
                        在为脚下的道路而不断前行
                        <br/>
                    </span>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>

<script>

export default {
    name: 'aboutUs',
    created() {

    },
    data() {
        return {
            
        }
    },
    mounted() {
        if(this.$userInfo.$userLimit === '') {
            this.$message({
                message:'不要乱来哦',
                type:'warning'
            });
            this.$router.push('/noZone');
        }
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('storyShow');
                }
            });
        })
        const hiddenElements = document.querySelectorAll('.storyHidden');
        hiddenElements.forEach((el) => observer.observe(el));
    },
    methods: {

    }
}
</script>


<style scoped lang="scss">
.content {
    font-family:"HMOS_Regular";
    font-size:18px;
    line-height: 36px;
}

.motto {
    font-family:"HMOS_Regular";
    font-size:15px;
    line-height: 30px;
}

.female {
    background-color: transparent;
    background-image: linear-gradient(#ff6363, #ff6363);
    background-repeat: no-repeat;
    background-size: 100% 30%;
    background-position: 0 100%;
}

.male {
    background-color: transparent;
    background-image: linear-gradient(#409eff, #409eff);
    background-repeat: no-repeat;
    background-size: 100% 30%;
    background-position: 0 100%;
}

.el-icon-female {
    color:#ff6363;
}

.el-icon-male {
    color:#409eff;
}

.icon {
    font-size:30px;
    font-weight:600;
}

.name {
    font-family: 'HMOS_Regular';
    font-size: 35px;
    line-height: 70px;
}

.item {
    display: inline-block;
    margin: 0 auto;
    width: 50vw;
    margin-top: 2vh;
    height: auto;
    margin-bottom: 10px;
    text-align: center;
}

mark {
    background-color: transparent;
    color: inherit;
    background-image: linear-gradient(#b83e46b5, #b83e46b5);
    background-repeat: no-repeat;
    background-size: 100% 30%;
    background-position: 0 100%;
}

.card {
    margin-top: 5vh;
}

.ourStoryBG {
    /* background-color:#bfa; */
    width: 100%;
    height: 100%;
    text-align: center;
    overflow: auto;
}

.storyHidden {
    filter: blur(5px);
    transform: translateY(50%);
    opacity: 0;
    transition: all 1000ms;
}

.storyHidden:nth-child(1) {
    transition-delay:500ms;
}

.storyHidden:nth-child(2) {
    transition-delay:2500ms;
}

.storyHidden:nth-child(3) {
    transition-delay:1000ms;
}

.storyShow {
    filter: blur(0);
    transform: translateY(0);
    opacity: 1;
}

::-webkit-scrollbar {
    display: none;
}
</style>